import Echo from 'laravel-echo';
import Config from "./config";
import Pusher from 'pusher-js';
import db from "./helpers/db";
window.Pusher = Pusher;

let connectionAttempts = 0;
const MAX_ATTEMPTS = 5;
const RETRY_INTERVAL = 60000; // 1 minuto em milissegundos
let retryTimeout = null;

// Função para obter os headers de autenticação atualizados
function getAuthHeaders() {
    return {
        'Authorization': 'Bearer ' + db.token,
        'ubbi-app': Config.app_name,
        'ubbi-app-token': Config.app_token,
        'ubbi-timezone': Config.timezone,
        'Current-Page-URL': window.location.href,
    };
}

// Função para validar se o token existe e é válido
function isTokenValid() {
    const token = db.token;
    return token && token !== 'null' && token !== 'undefined' && token.trim().length > 0;
}

// Função para criar a instância do Echo
function createEchoInstance() {
    if (window.Echo) {
        console.log('[WebSocket] Instância do Echo já existe.');
        return true;
    }

    try {
        window.Echo = new Echo({
            authEndpoint: Config.base_url + '/broadcasting/auth',
            auth: {
                headers: getAuthHeaders()
            },
            broadcaster: 'reverb',
            key: process.env.VUE_APP_REVERB_APP_KEY,
            wsHost: process.env.VUE_APP_REVERB_HOST,
            wsPort: process.env.VUE_APP_REVERB_PORT,
            wssPort: process.env.VUE_APP_REVERB_PORT,
            forceTLS: (process.env.VUE_APP_REVERB_SCHEME ?? 'https') === 'https',
            enabledTransports: ['ws', 'wss'],
        });

        // Intercepta os requests de autenticação para garantir que o token esteja sempre atualizado
        if (window.Echo && window.Echo.connector && window.Echo.connector.pusher) {
            const originalAuthorizer = window.Echo.connector.pusher.config.auth;
            
            window.Echo.connector.pusher.config.auth = {
                ...originalAuthorizer,
                headers: getAuthHeaders()
            };
        }

        console.log('[WebSocket] Conexão estabelecida com sucesso.');
        connectionAttempts = 0; // Reset tentativas após sucesso
        return true;
    } catch (error) {
        console.error('[WebSocket] Erro ao criar instância do Echo:', error);
        return false;
    }
}

// Função para tentar conectar no websocket com retry
function attemptConnection() {
    // Limpa timeout anterior se existir
    if (retryTimeout) {
        clearTimeout(retryTimeout);
        retryTimeout = null;
    }

    if (!isTokenValid()) {
        connectionAttempts++;
        console.warn(`[WebSocket] Token inválido ou não encontrado. Tentativa ${connectionAttempts}/${MAX_ATTEMPTS}`);

        if (connectionAttempts < MAX_ATTEMPTS) {
            console.log(`[WebSocket] Nova tentativa em ${RETRY_INTERVAL / 1000} segundos...`);
            retryTimeout = setTimeout(() => {
                attemptConnection();
            }, RETRY_INTERVAL);
        } else {
            console.error('[WebSocket] Número máximo de tentativas de conexão atingido.');
            connectionAttempts = 0; // Reset para permitir novas tentativas futuras
        }
        return false;
    }

    return createEchoInstance();
}

// Função principal para inicializar o websocket
export function initWebSocket() {
    console.log('[WebSocket] Iniciando conexão...');
    
    if (window.Echo) {
        console.log('[WebSocket] Já conectado.');
        return true;
    }

    return attemptConnection();
}

// Função para desconectar o websocket
export function disconnectWebSocket() {
    if (retryTimeout) {
        clearTimeout(retryTimeout);
        retryTimeout = null;
    }

    if (window.Echo) {
        try {
            window.Echo.disconnect();
            window.Echo = null;
            console.log('[WebSocket] Desconectado com sucesso.');
        } catch (error) {
            console.error('[WebSocket] Erro ao desconectar:', error);
        }
    }
    
    connectionAttempts = 0;
}

// Função para reconectar (útil após renovar token)
export function reconnectWebSocket() {
    console.log('[WebSocket] Reconectando...');
    disconnectWebSocket();
    return initWebSocket();
}